import { Grid, Typography, useTheme } from "@mui/material";
import AcxEmptyState from "components/UI/AcxEmptyStateIndicator/AcxEmptyState";
import { sanitizeTextCardHtml } from "utils/sanitizeHtml";
import { observer } from "mobx-react";
import { TextCardMenu } from "./TextCardMenu";
import TextCardStore from "./TextCardStore";
import "quill/dist/quill.snow.css";
import { defaultShadowsForSignals } from "components/Signals/SignalsUtils";

const TextCard = observer(({ store }: { store: TextCardStore }) => {
    const theme = useTheme();
    const isLoading = store.getTaskLoading("refresh");

    // This is separated out so we can wrap the loading state correctly
    const renderContent = () => {
        if (isLoading) {
            return <AcxEmptyState variant="loading" size="small" />;
        }

        return (
            <Grid
                container
                item
                xs={12}
                wrap="nowrap"
                justifyContent={"space-between"}
                padding={theme.spacing(2)}
                paddingRight={theme.spacing(3)}
                paddingLeft={theme.spacing(3)}
            >
                {/* The menu keeps its width; the text takes the rest. */}
                <Grid item container sx={{ flex: "1 1 auto", minWidth: 0 }}>
                    <div
                        className="ql-editor"
                        dangerouslySetInnerHTML={{
                            __html: sanitizeTextCardHtml(store.cardText),
                        }}
                        style={{
                            backgroundColor: theme.palette.white.background,
                            width: "100%",
                        }}
                    ></div>
                </Grid>
                {!store.isPresentationMode &&
                    (store.isEditable || store.isDeletable) && (
                        <TextCardMenu store={store} />
                    )}
            </Grid>
        );
    };

    return (
        <Grid
            id={store.id}
            sx={{
                width: "100%",
                height: "100%",
                borderRadius: 2,
                boxShadow: defaultShadowsForSignals,
                backgroundColor: theme.palette.white.main,
            }}
        >
            {renderContent()}
            {store.error && (
                <Typography
                    padding={theme.spacing(2)}
                    color={theme.palette.error.main}
                >
                    {store.error}
                </Typography>
            )}
        </Grid>
    );
});

export default TextCard;
